<nav class="navbar gung-navbar navbar-expand-md d-block">
  <div class="d-flex justify-content-center align-items-center navbar-items">
    <div class="navbar-nav flex-grow-0">
      <div class="nav-option nav-item" *ngIf="mainMenu">
        <i class="fas fa-bars"> </i>
        <div class="gung-mega-menu">
          <div class="container">
            <div class="row">
              <div class="col-6 col-md-3 col-lg-2 link-block" *ngFor="let linkGroup of mainMenu.links">
                <h6>
                  <a
                    [routerLink]="linkGroup.link ? linkGroup.link : undefined"
                    [routerLinkActive]="linkGroup.link ? 'active' : ''"
                    (click)="linkGroup.action ? linkGroup.action() : undefined"
                  >
                    <i *ngIf="linkGroup.icon" class="fa {{ linkGroup.icon }} mr-2"></i>
                    <span translate>{{ linkGroup.heading }}</span></a
                  >
                </h6>

                <ul>
                  <li *ngFor="let childLink of linkGroup.links">
                    <a
                      [routerLink]="childLink.link ? childLink.link : undefined"
                      [routerLinkActive]="childLink.link ? 'active' : ''"
                      (click)="childLink.action ? childLink.action() : undefined"
                    >
                      <i *ngIf="childLink.icon" class="fa {{ childLink.icon }} mr-2"></i>
                      <span translate>{{ childLink.heading }}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="logo">
      <div class="nav-brand-wrapper d-flex justify-content-center">
        <a class="navbar-brand" routerLink="/" style="margin-top: -5px">
          <img src="{{ logoUrl }}" width="auto" height="36px" alt="Logotype" />
        </a>
        <a class="navbar-brand pl-3" routerLink="/" style="margin-top: -5px">
          <img src="./assets/logotype-cult.png" width="auto" height="36px" alt="Logotype" />
        </a>
      </div>
    </div>
    <!-- <div class="right-menu" [ngClass]="{'flex-grow-0': rightMenus.length <= 0}">
    </div> -->
    <div *ngIf="isAnonymous" class="icons-top-wrapper d-flex">
      <a class="px-0 text-center" [routerLink]="'/login'">
        <div class="text-primary">
          <i class="fal fa-user"></i>
        </div>
        <div class="nav-bar-icon-title text-primary">
          <span>{{ 'LOGIN' | translate }}</span>
        </div>
      </a>
    </div>

    <div *ngIf="!isAnonymous">
      <div class="right-menu nav-bar-item-text text-truncate center-customer-name">
        <div *ngIf="authenticated" class="d-flex pr-7">
          <strong>{{ 'CURRENT_CUSTOMER' | translate }}:&nbsp;</strong>
          <a *ngIf="topInformation" routerLink="{{ topInformation.link }}">
            <strong
              ><span>{{ topInformation.heading | uppercase }}</span></strong
            >
          </a>
        </div>
      </div>
      <div *ngIf="authenticated" class="icons-top-wrapper d-flex">
        <!-- <a class="px-0 text-center" [routerLink]="'/favourites'">
          <div class="text-primary">
            <i class="fal fa-heart"></i>
            <span class="badge badge-primary nav-bar-icon-badge">{{ favouritesCount }}</span>
          </div>
          <div class="nav-bar-icon-title text-primary">
            <span>{{'FAVOURITES' | translate }}</span>
          </div>
        </a> -->

        <div class="pl-3">
          <cult-navbar-cart *ngIf="isCartVisible"></cult-navbar-cart>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex container justify-content-center align-items-center navbar-items navbar-top-extra-menu pl-md-4">
    <div class="left-menu nav-bar-item-text">
      <div class="mr-auto">
        <div *ngIf="!showFlowsAsDropdown" class="mobile-flow ml-3" (click)="toggleShowLeftMenu()">
          {{ currentFlowName }}
          <i *ngIf="!showLeftMenu" class="ml-2 fa fa-angle-down"></i>
          <i *ngIf="showLeftMenu" class="ml-2 fa fa-angle-up"></i>
        </div>
        <ul
          class="navbar-nav"
          *ngIf="leftMenus"
          [ngClass]="{
            hideflowmobile: !showFlowsAsDropdown,
            'show-left-menu': showLeftMenu,
            'fix-mobile-pos': showFlowsAsDropdown
          }"
        >
          <li class="nav-item" *ngFor="let leftMenuLink of leftMenus; index as leftMenuIndex">
            <div class="nav-item nav-link" id="nav-item-{{ leftMenuIndex }}">
              <a
                class="px-0"
                [routerLink]="!leftMenuLink.links && leftMenuLink.link ? leftMenuLink.link : undefined"
                (click)="
                  leftMenuLink.action ? leftMenuLink.action() : undefined;
                  leftMenuLink.links && leftMenuLink.links.length > 0 ? toggleTopMenuV2(leftMenuIndex) : undefined
                "
                [ngClass]="{ active: currentFlowName === leftMenuLink.heading }"
              >
                <i *ngIf="leftMenuLink.icon" class="fa {{ leftMenuLink.icon }} mr-2"></i>
                <span>{{ leftMenuLink?.heading | translate | uppercase }}</span>
                <i
                  *ngIf="
                    leftMenuLink.links &&
                    leftMenuLink.links.length > 0 &&
                    (!isTopMenuExpanded || topMenuExpandedNumber !== leftMenuIndex)
                  "
                  class="fas fa-angle-down pl-2"
                ></i>
                <i
                  *ngIf="
                    leftMenuLink.links &&
                    leftMenuLink.links.length > 0 &&
                    isTopMenuExpanded &&
                    (isNaN(topMenuExpandedNumber) || topMenuExpandedNumber === leftMenuIndex)
                  "
                  class="fas fa-angle-up pl-2"
                ></i>
              </a>
              <div
                id="gung-mega-top-menu"
                *ngIf="leftMenuLink.links"
                class="gung-mega-menu gung-mega-top-menu-collapsed"
              >
                <div class="row">
                  <div
                    class="col-1 dropdown-sub-element link-block"
                    *ngFor="let linkGroup of leftMenuLink.links; index as topMainMenuIndex"
                  >
                    <h6>
                      <a
                        [routerLink]="linkGroup?.link ? linkGroup.link : undefined"
                        [routerLinkActive]="linkGroup?.link && ( currentFlowName === leftMenuLink.heading )  ? 'active' : ''"
                        (click)="
                          linkGroup?.action ? linkGroup.action() : undefined;
                          selectedTopMainMenuIndex = topMainMenuIndex
                        "
                      >
                        <i *ngIf="linkGroup?.icon" class="fa {{ linkGroup.icon }} mr-2"></i>
                        <span translate>{{ linkGroup?.heading | uppercase }}</span></a
                      >
                    </h6>

                    <ul
                      [ngClass]="{
                        'gung-mega-top-main-menu-expanded':
                          isSmallScreen && selectedTopMainMenuIndex === topMainMenuIndex,
                        'gung-mega-top-main-menu-collapsed':
                          isSmallScreen && selectedTopMainMenuIndex !== topMainMenuIndex
                      }"
                    >
                      <li *ngFor="let childLink of linkGroup?.links">
                        <a
                          [routerLink]="childLink.link ? childLink.link : undefined"
                          [routerLinkActive]="childLink.link ? 'active' : ''"
                          (click)="childLink.action ? childLink.action() : undefined"
                        >
                          <i *ngIf="childLink.icon" class="fa {{ childLink.icon }} mr-2"></i>
                          <span translate>{{ childLink.heading | uppercase }}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="right-menu nav-bar-item-text text-truncate" *ngIf="!isAnonymous">
      <div *ngIf="authenticated" class="d-flex">
        <!-- <a *ngIf="topInformation" class="pr-3" routerLink="{{topInformation.link}}">
          <span>{{topInformation.heading | uppercase}}</span>
        </a> -->
        <a class="px-0 pr-3 side-menu-icon" (click)="sidenavToggleEvent()">
          <i class="fas fa-bars"></i>
        </a>
      </div>
    </div>
  </div>
</nav>
